import React from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Option } from "../../../utils/Types";

const SelectOption = ({ option, select, setPage, setSelect }: any) => {
  const handleSelect = (event: SelectChangeEvent) => {
    setPage(1);
    setSelect(event.target.value as string);
  };

  return (
    <div className="test-dropdown">
      <FormControl style={{ height: "32px" }} fullWidth>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={select}
          onChange={handleSelect}
          style={{
            height: "32px",
            // color:"black"
            background: "#0555c8",
            color: "#fff",
          }}
        >
          {option?.map((value: Option) => (
            <MenuItem key={value?.value} value={value?.value}>
              {value?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default SelectOption;
